import { Info } from "lucide-react";
import { Text, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@musa.tech/design-system";
import { useCountUp } from "@/hooks/useCountUp";
import { fmtCompactNumber } from "@/utils/formatCompactNumber";
import { CompactValue } from "./CompactValue";
import { KpiCardShell } from "./KpiCardShell";

interface UnitsRegisteredCardProps {
  registeredCount: number;
  withCollectsCount: number;
}

/**
 * Card 1 "Estabelecimentos cadastrados" — sem a linha de operadores
 * homologados (decisão: ship sem esse submétrica agora, backend fica pra
 * depois).
 * Layout e cores conferidos no Figma (node 124:12999): linha de submétrica
 * em label/small neutral-700, ícone de Info à direita.
 */
export const UnitsRegisteredCard = ({
  registeredCount,
  withCollectsCount,
}: UnitsRegisteredCardProps) => {
  // A submétrica conta junto com o número principal: se só o de cima animasse,
  // o card leria "0 unidades cadastradas / 1.635 unidades com coletas" durante
  // a contagem — impossível, e visível por quase um segundo.
  const animatedCount = useCountUp(registeredCount);
  const animatedWithCollects = useCountUp(withCollectsCount);

  return (
  <KpiCardShell
    label="Estabelecimentos cadastrados"
    header={
      <Text className="text-2xl font-semibold leading-9 tracking-normal text-neutral-900">
        <CompactValue exact={registeredCount} unit="estabelecimentos">
          {fmtCompactNumber(animatedCount)}
        </CompactValue>
      </Text>
    }
    rows={
      <div className="flex items-center justify-between gap-2">
        <Text variant="label" size="small" className="min-w-0 text-neutral-700">
          <CompactValue exact={withCollectsCount} unit="estabelecimentos">

            {fmtCompactNumber(animatedWithCollects)}
          </CompactValue>{" "}
          estabelecimentos com coletas
        </Text>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="h-5 w-5 shrink-0 cursor-help text-neutral-700" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs text-xs leading-relaxed">
              Quantidade de estabelecimentos que registraram pelo menos uma coleta no
              período selecionado.
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    }
  />
  );
};
